import { Pago, TipoPago } from '@/types';

export interface PaymentStatusBadge {
  label: 'Pagado' | 'Cobrado' | 'Atrasado' | 'Pendiente';
  className: string;
  icon: string;
}

type PaymentStatusInput = Pick<Pago, 'tipo' | 'estado' | 'fecha_limite'>;

function startOfDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function dueDate(date: string): Date | null {
  const [year, month, day] = date.slice(0, 10).split('-').map(Number);
  return year && month && day ? new Date(year, month - 1, day) : null;
}

export function getPaymentStatusBadge(
  payment: PaymentStatusInput,
  currentDate: Date = new Date(),
): PaymentStatusBadge | null {
  if (payment.estado === 'PAGADO') {
    return payment.tipo === TipoPago.PROPIETARIO
      ? { label: 'Cobrado', className: 'bg-green-100 text-green-800 border-green-200', icon: '✓' }
      : { label: 'Pagado', className: 'bg-green-100 text-green-800 border-green-200', icon: '✓' };
  }

  const limit = dueDate(payment.fecha_limite);
  const today = startOfDay(currentDate);

  if (payment.estado === 'ATRASADO' || (payment.estado === 'PENDIENTE' && limit !== null && limit < today)) {
    return { label: 'Atrasado', className: 'bg-red-100 text-red-800 border-red-200', icon: '!' };
  }

  if (payment.tipo === TipoPago.PROPIETARIO && payment.estado === 'PENDIENTE' && limit !== null && limit <= today) {
    return { label: 'Pendiente', className: 'bg-yellow-100 text-yellow-800 border-yellow-200', icon: '⏳' };
  }

  return null;
}
